'use strict';

angular.module('app')

.run(function (Template) {}) // jshint ignore:line

.factory('Template', function (DS) {
    return DS.defineResource({
        name: 'Template',
        endpoint: 'templates',
        upsert: true,
    });
});
